import { createSlice } from "@reduxjs/toolkit";
import { fetchAllForms, fetchCarriers, fetchPolicies } from "../Actions";


const FORM_MANGMENT_SLICE_NAME = "formMangmentslice";

const formInitialState = {
  carrier: [],
  policy: [],
  allForms: [],
  isLoading: false,
  formList: [],
  showPopup: false
};

const formMangmentslice = createSlice({
  name: FORM_MANGMENT_SLICE_NAME,
  initialState: formInitialState,
  reducers: {
    onSortingData(state, action) {
      state.formList = action.payload;
      return state;
    },
    handleShowPopup(state, action) {
      state.showPopup = action.payload
    }
  },
  extraReducers: (builder) => {
    //@ts-ignore
    builder
      .addCase(fetchCarriers.pending, (state) => {
        state.isLoading = true;
        state.carrier = {};
        state.allForms = [];
        return state;
      })
      .addCase(
        fetchCarriers.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.carrier = action.payload;
          state.allForms = [];
          return state;
        }
      )
      .addCase(
        fetchCarriers.rejected,
        (state) => {
          state.isLoading = false;
          state.allForms = [];
        }
      )

      //fetch policies
      .addCase(fetchPolicies.pending, (state) => {
        state.isLoading = true;
        state.policy = [];
        return state;
      })
      .addCase(
        fetchPolicies.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.policy = action.payload;
          return state;
        }
      )
      .addCase(
        fetchPolicies.rejected,
        (state) => {
          state.isLoading = false;
        }
      )


      //fetch all forms

      .addCase(fetchAllForms.pending, (state) => {
        state.isLoading = true;
        state.allForms = {};
        return state;
      })
      .addCase(
        fetchAllForms.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.allForms = action.payload;
          state.formList = action.payload.data.forms;
          state.showPopup = action.payload.data.showPopup;
          return state;
        }
      )
      .addCase(
        fetchAllForms.rejected,
        (state) => {
          state.isLoading = false;
        }
      );
  },
});

export const { onSortingData, handleShowPopup } = formMangmentslice.actions;
export const formMangmentReducer = formMangmentslice.reducer;
